import React__default from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusSuccess } from '@grandvisionhq/state';
import { useRxGlassesConfiguratorContext } from '../../Context/RxGlassesConfiguratorContext.js';
import { ProductSelectionStep } from '../components/ProductSelectionStep/ProductSelectionStep.js';
import { getSelectedFrame, getPackages, getSelectedPackage } from '../../../state/configurator/selectors.js';
import { selectPackage } from '../../../state/configurations/actions.js';

const LensPackageStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const { configuratorDocument  } = useRxGlassesConfiguratorContext();
    var ref;
    const { readMoreLink  } = (ref = configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.packageStep) !== null && ref !== void 0 ? ref : {};
    const frame = useSelector(getSelectedFrame);
    const lensPackages = useSelector(getPackages);
    const selectedLensPackage = useSelector(getSelectedPackage);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectPackage({
            frameSku: frame.sku,
            packageSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensPackages)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: lensPackages.result,
        selectedItemSku: selectedLensPackage === null || selectedLensPackage === void 0 ? void 0 : selectedLensPackage.sku,
        readMoreLink: readMoreLink
    });
};

export { LensPackageStepContainer };
//# sourceMappingURL=LensPackageStepContainer.js.map
